import React from 'react';
import swal from 'sweetalert2';
import { telechargerFichier } from '../../../App_Code/API';
import Card, { LigneCard } from '../../Card';
import creationProcedureSignature from './FormProcedureSignature';


function formeIBAN(iban) {
    if (iban.length <= 4) { return iban; }
    return `${iban.substring(0, 4)} ${formeIBAN(iban.substring(4, iban.length))}`;
}

const SignatureManuscrite = (IdMandatInactif) => {
    window.open(telechargerFichier(IdMandatInactif), '_blank');
    swal({
        title: 'Signature manuscrite',
        text: "Votre mandat vient d'être téléchargé, imprimez, datez, signez et envoyez-le à l’adresse de votre agence.",
        type: 'info',
    });
};

const SignatureElectronique = (NumRum, IdMandat, IdSignature, link) => {
    if (IdSignature) {
        if(IdSignature === "unauthorized")  {
            swal('Interdit', 'Vous n\'avez pas la permission', 'error');
            return
        }   
        link.push('/MesInformations/SaisieRIB/Signature', IdSignature);
    } else {
        creationProcedureSignature(NumRum, IdMandat, link);
    }
};

const ModePrelevement = (ModePrl) => {
    switch (ModePrl) {
    case 1:
        return "Automatique à l'exigibilité";
    case 2:
        return 'Automatique mensualisé';
    case 3:
        return 'Manuel à la demande';
    default:
        return 'Non défini';
    }
};

const CardMandatEnCours = ({
    Mandat, Link, SignElecOk,
}) => {
    if (!Mandat.MandatInactif) return null;
    if (!Mandat.MandatInactif.Iban || !Mandat.MandatInactif.Bic) return null;

    return (
        <Card Titre="Mandat inactif">
            <div className="alert-warning mb-2 p-2">
                <span><strong>Attention !</strong><br />
                    { Mandat.ProcedureEnCours
                        ? 'Veuillez terminer la procédure de signature électronique de ce mandat. En attendant, toute création de nouveau mandat vous sera impossible.'
                        : "La création de ce mandat n'a pas été finalisée. Pour activer ce mandat il ne vous reste qu'à le signer. Si ce mandat est faux, merci d'en créer un nouveau." }
                </span>
            </div>
            {Mandat.ModePrl ? <LigneCard titre="Mode" valeur={ModePrelevement(Mandat.ModePrl)} /> : null }
            <LigneCard titre="IBAN" valeur={formeIBAN(Mandat.MandatInactif.Iban)} classeValeur="font-weight-bold" />
            <LigneCard titre="BIC" valeur={Mandat.MandatInactif.Bic} />
            <LigneCard titre="RUM" valeur={`n° ${Mandat.MandatInactif.Rum}`} derniereLigne />
            { !Mandat.ProcedureEnCours ?
                <div className="mt-3 d-flex justify-content-center">
                    {SignElecOk ?
                        <React.Fragment>
                            <button className="btn btn-outline-primary mr-3 w-50" onClick={() => { SignatureElectronique(Mandat.MandatInactif.Rum, Mandat.MandatInactif.IdMandatInactif, Mandat.MandatInactif.IdSignature, Link); }}>
                                <i className="fas fa-pen" /><span> Signer</span>
                            </button>
                            <button className="btn btn-outline-success w-50" onClick={() => { SignatureManuscrite(Mandat.MandatInactif.IdMandatInactif); }}>
                                <i className="fa fas fa-download" /><span> Télécharger</span>
                            </button>
                        </React.Fragment> :
                        <button className="btn btn-outline-success w-75" onClick={() => { SignatureManuscrite(Mandat.MandatInactif.IdMandatInactif); }}>
                            <i className="fa fas fa-download" /><span> Télécharger</span>
                        </button>
                    }
                </div> :
                <div className="mt-3 d-flex justify-content-around">
                    <button className="btn btn-outline-orange w-75" onClick={() => { SignatureElectronique(Mandat.MandatInactif.Rum, Mandat.MandatInactif.IdMandatInactif, Mandat.MandatInactif.IdSignature, Link); }}>
                        <i className="fa fas fa-warning" /><span> Finaliser la procédure</span>
                    </button>
                </div>
            }
        </Card>
    );
};
CardMandatEnCours.displayName = 'CardMandatEnCours';
CardMandatEnCours.requiredProps = [
    'Mandat', // Mandat SEPA
    'Link', // this.props.history
];


export default CardMandatEnCours;



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/CardMandatEnCours.js